import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { SidebarContainer, SidebarOverlay } from './Sidebar.styles';

const Sidebar = ({ isOpen, onClose, children, isLeftSide = false }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflowY = 'hidden';
    } else {
      document.body.removeAttribute('style');
    }

    if (!isOpen || !onClose) {
      return undefined;
    }

    const listener = window.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    });

    return () => {
      window.removeEventListener('keyup', listener);
    };
  }, [isOpen, onClose]);

  const handleContainerClick = (event) => event.stopPropagation();

  return (
    <>
      <SidebarOverlay isOpen={isOpen} data-cy="sidebar-overlay" />
      <SidebarContainer isOpen={isOpen} isLeftSide={isLeftSide} data-cy="sidebar-container" onClick={handleContainerClick}>
        {React.Children.map(children, (child) => React.cloneElement(child, { onClose }))}
      </SidebarContainer>
    </>
  );
};

Sidebar.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  children: PropTypes.node,
  isLeftSide: PropTypes.bool
};

export default Sidebar;
